import { getSubStepValues } from '#models/general/steps';
import { FROM_0_TO_999_W1_DECIMAL_REGEX, FIVE_NUMBERS_REGEX } from '#utils/string/regex';
import Input from '#components/general/Input';
import { MEASURE_TYPES } from '#components/general/Input/components/Measure/constants';

import { SPIRIT_DIPS_FIELDS, SPIRIT_SUBSTEPS_IDS } from './constants';

export const getDipsFields = ({ values, errors }) => {
  const getDipsValues = getSubStepValues(SPIRIT_SUBSTEPS_IDS.DIPS, values, errors);
  return [
    {
      ...getDipsValues(SPIRIT_DIPS_FIELDS.LWFR_DIP_HEIGHT),
      Component: Input,
      needsRegex: true,
      customRegex: FROM_0_TO_999_W1_DECIMAL_REGEX,
      measure: MEASURE_TYPES.LENGTH
    },
    {
      ...getDipsValues(SPIRIT_DIPS_FIELDS.LWFR_DIP_VOLUME),
      Component: Input,
      needsRegex: true,
      customRegex: FIVE_NUMBERS_REGEX,
      measure: MEASURE_TYPES.LITRES
    }
  ];
};
